import { Device, getDeviceSchema, MATCH_START } from "callable-data-objects";
import { CallableInput } from "Components/Shared";
import FormSubmit from "Components/Shared/FormSubmit";
import SimpleBreadcrumbs from "Components/Shared/SimpleBreadcrumbs";
import { Field, Formik } from "formik";
import { useDevice } from "Hooks/Endpoints";
import React, { Fragment, useEffect, useState } from "react";
import { Divider, Form, Header, Message, Segment } from "semantic-ui-react";

const CreateOutboundFlowForm = () => {
  const {
    submitting,
    devices,
    saveFlow,
    nextExtension,
    validateExtension,
    validateName,
    uncreate,
  } = useDevice();

  const [canCreate, setCanCreate] = useState<boolean>(false);

  const initValues = {
    type: MATCH_START,
    name: "",
    extension: nextExtension,
    regexRoute: {
      regExp: ".*",
      connectTo: "HANGUP",
    },
  };

  useEffect(() => {
    if (devices) {
      const found = devices.find((d: Device) => d.type === MATCH_START);
      setCanCreate(!found);
    }
  }, [devices]);

  return (
    <Fragment>
      <SimpleBreadcrumbs
        title='Outbound Flows'
        subtitle='Create'
        onBack={uncreate}
      />
      <Segment>
        <Header as='h3'>Create Outbound Flow</Header>
        <Divider />
        {!canCreate && (
          <Message color='blue'>
            <Message.Header>Cannot create Outbound Flow</Message.Header>
            <p>You already have an outbound flow attached to this account</p>
          </Message>
        )}
        {canCreate && (
          <Formik
            initialValues={initValues}
            validationSchema={getDeviceSchema(MATCH_START)}
            onSubmit={(values, actions) => {
              saveFlow(values);
            }}
          >
            {(props) => (
              <Form onSubmit={props.handleSubmit}>
                <Field
                  name='name'
                  label='Name'
                  validate={validateName}
                  component={CallableInput}
                />
                <Field
                  name='extension'
                  label='Extension'
                  placeholder='100'
                  type='number'
                  validate={validateExtension}
                  component={CallableInput}
                />
                <FormSubmit
                  name='Create'
                  errors={props.errors}
                  submitting={submitting}
                />
              </Form>
            )}
          </Formik>
        )}
      </Segment>
    </Fragment>
  );
};

export default CreateOutboundFlowForm;
